// src/navigations/path.jsx - Centralized route paths

// Dashboard
export const DASHBOARD_PATH = "/dashboard";

// Merchant Routes
export const CREATE_MERCHANT = "/create-merchant";
export const IN_UNDERWRITING_PATH = "/in-underwriting";
export const MERCHANT_ACCOUNTS_LIST = "/merchants/accounts";
export const PENDING_PATH = "/pending";
export const COMPLETE_PATH = "/complete";

// User Management Routes
export const USERS_LIST_PATH = "/users-list";
export const TEAMS_LISTS_PATH = "/teams-lists";
export const CREATE_TEAM = "/create-team";
export const CREATE_USER = "/create-user";

// Customer Management Routes
export const CUSTOMERS_LIST_PATH = "/customers-list";
export const CREATE_CUSTOMER = "/create-customer";

// Sales DBA
export const SALES_DBA_LISTING = "/sales-dba";

// Profile
export const PROFILE_PATH = "/profile";
export const Profile_page = "/profile";

// Notifications
export const NOTIFICATIONS_PATH = "/notifications";

// Leads Routes
export const LEADS_PATH = "/leads";
export const LEADS_CREATE_PATH = "/leads/create";

// Permissions & roles
export const ROLES_LIST_PATH = "/roles";
export const ROLES_CREATE_PATH = "/roles/create";
export const ROLES_EDIT_PATH = "/roles/edit";
/** @deprecated use ROLES_LIST_PATH */
export const ROLE_PERMISSION = "/permission/role";
export const USER_PERMISSION = "/permissions/assign";

// Issues
export const ISSUE_LIST_PAGE = "/issues";

// Contracts
export const CONTRACTS_LIST_PATH = "/contracts";

// Invoices
export const INVOICES_LIST_PATH = "/invoices";
export const INVOICES_CREATE_PATH = "/invoices/create";
export const INVOICES_EDIT_PATH = "/invoices/edit";
export const INVOICES_VIEW_PATH = "/invoices/view";

// Payments
export const PAYMENTS_LIST_PATH = "/payments";
export const PAYMENTS_VIEW_PATH = "/payments/view";

// Payment errors
export const PAYMENT_ERRORS_LIST_PATH = "/payment-errors";
export const PAYMENT_ERRORS_VIEW_PATH = "/payment-errors/view";

// Payment accounts
export const PAYMENT_ACCOUNTS_LIST_PATH = "/payment-accounts";
export const PAYMENT_ACCOUNTS_CREATE_PATH = "/payment-accounts/create";
export const PAYMENT_ACCOUNTS_EDIT_PATH = "/payment-accounts/edit/:id";
export const PAYMENT_ACCOUNTS_VIEW_PATH = "/payment-accounts/view/:id";

// Brands
export const BRANDS_LIST_PATH = "/brands";
export const BRANDS_CREATE_PATH = "/brands/create";
export const BRANDS_VIEW_PATH = "/brands/view";

// Services
export const SERVICES_LIST_PATH = "/services";
export const SERVICES_CREATE_PATH = "/services/create";
export const SERVICES_VIEW_PATH = "/services/view";

// Companies
export const COMPANIES_LIST_PATH = "/companies";
export const COMPANIES_CREATE_PATH = "/companies/create";
export const COMPANIES_VIEW_PATH = "/companies/view";

// Task types
export const TASK_TYPES_LIST_PATH = "/task-types";
export const TASK_TYPES_CREATE_PATH = "/task-types/create";
export const TASK_TYPES_VIEW_PATH = "/task-types/view";

// Task categories
export const TASK_CATEGORIES_LIST_PATH = "/task-categories";
export const TASK_CATEGORIES_CREATE_PATH = "/task-categories/create";
export const TASK_CATEGORIES_VIEW_PATH = "/task-categories/view";

// Task templates
export const TASK_TEMPLATES_LIST_PATH = "/task-templates";
export const TASK_TEMPLATES_CREATE_PATH = "/task-templates/create";
export const TASK_TEMPLATES_VIEW_PATH = "/task-templates/view";

// Tasks
export const TASKS_LIST_PATH = "/tasks";
export const TASKS_CREATE_PATH = "/tasks/create";
export const TASKS_VIEW_PATH = "/tasks/view";

// Lead quizzes
export const LEAD_QUIZZES_LIST_PATH = "/lead-quizzes";
export const LEAD_QUIZZES_CREATE_PATH = "/lead-quizzes/create";
export const LEAD_QUIZZES_VIEW_PATH = "/lead-quizzes/view";

// Daily Summary
export const DAILY_SUMMARY_LIST_PATH = "/daily-summary";
export const DAILY_SUMMARY_CREATE_PATH = "/daily-summary/create";
export const DAILY_SUMMARY_VIEW_PATH = "/daily-summary/view";

// Calls Counter Summary
export const CALLS_COUNTER_SUMMARY_PATH = "/calls-counter-summary";

// Leads Report
export const LEADS_REPORT_PATH = "/leads-report";

// Lead reports (sales / payments / status)
export const LEAD_REPORT_GENERATE_SALES_PATH =
  "/reports/generate-sales-information";
export const LEAD_REPORT_PAYMENT_SUMMARY_PATH =
  "/reports/generate-payment-summary";
export const LEAD_REPORT_CLIENTS_AS_PER_STATUS_PATH =
  "/reports/clients-as-per-status";

// Call recordings
export const CALL_RECORDS_LIST_PATH = "/call-records";
export const CALL_RECORDS_CREATE_PATH = "/call-records/create";
export const CALL_RECORDS_VIEW_PATH = "/call-records/view";
export const CALL_RECORDS_EDIT_PATH = "/call-records/edit";

// Recent Activities (Reports)
export const RECENT_ACTIVITIES_REPORT_PATH = "/reports/recent-activities";

// Calendar / Meetings
export const CALENDAR_SCHEDULE_PATH = "/meetings/calendar";
export const MEETING_CREATE_PATH = "/meetings/create";
export const MEETING_EDIT_PATH = "/meetings/edit";
export const MEETING_VIEW_PATH = "/meetings/view";

// Order
export const ORDER_LIST_PATH = "/orders";
export const ORDER_CREATE_PATH = "/orders/create";
export const ORDER_EDIT_PATH = "/orders/edit/:id";
export const ORDER_VIEW_PATH = "/orders/view/:id";

// Service Plans
export const SERVICE_PLANS_LIST_PATH = "/service-plans";
export const SERVICE_PLANS_CREATE_PATH = "/service-plans/create";
export const SERVICE_PLANS_EDIT_PATH = "/service-plans/edit/:id";
export const SERVICE_PLANS_VIEW_PATH = "/service-plans/view/:id";

// Service State Price
export const SERVICE_STATE_PRICES_LIST_PATH = "/service-state-price";
export const SERVICE_STATE_PRICES_CREATE_PATH = "/service-state-price/create";
export const SERVICE_STATE_PRICES_EDIT_PATH = "/service-state-price/edit/:id";
export const SERVICE_STATE_PRICES_VIEW_PATH = "/service-state-price/view/:id";
